"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateArtifactRequest () {
        return CreateArtifactRequest;
    },
    get RenderRequest () {
        return RenderRequest;
    },
    get ReportingChatStreamRequest () {
        return ReportingChatStreamRequest;
    },
    get UpdateArtifactRequest () {
        return UpdateArtifactRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const ReportingChatStreamRequest = _zod.z.object({
    query: _zod.z.string().min(1).max(4000),
    messages: _zod.z.array(_zod.z.object({
        role: _zod.z.enum([
            "user",
            "assistant"
        ]),
        content: _zod.z.string().max(20_000)
    })).max(50).default([]),
    notes: _zod.z.record(_zod.z.string(), _zod.z.unknown()).refine((val)=>JSON.stringify(val).length <= 10_000, {
        message: "Notes payload too large"
    }).nullish()
});
const CreateArtifactRequest = _zod.z.object({
    name: _zod.z.string().trim().min(1),
    outputType: _zod.z.enum([
        "answer",
        "table",
        "chart"
    ]),
    // nullish, not just optional: answer artifacts are text snapshots with no re-runnable query,
    // and a GET artifact response round-tripped straight back into a request carries `query: null`
    // (Mongo stores an explicitly-undefined field as null) rather than an absent key.
    query: _models.ArtifactReportQuery.nullish(),
    output: _models.ArtifactOutput,
    // Optional: chat-history saving was deferred post-prototype.
    chatHistory: _zod.z.array(_models.ArtifactChatMessage).optional()
})// table/chart reopen re-runs the query via /render; only answer snapshots may omit it.
.refine((val)=>val.outputType === "answer" || val.query != null, {
    message: "table and chart artifacts require a query",
    path: [
        "query"
    ]
})// chart reopen re-runs the query and needs the chart mapping; renderArtifact rejects a chart
// missing any of these, so a chart artifact can't be persisted without them.
.refine((val)=>val.outputType !== "chart" || !!val.output.chartType && !!val.output.categoryField && !!val.output.valueField, {
    message: "chart artifacts require chartType, categoryField, and valueField",
    path: [
        "output"
    ]
})// An answer artifact is only its text snapshot; renderArtifact falls back to "" on reopen, so a
// title-only answer would persist as a permanently blank report.
.refine((val)=>val.outputType !== "answer" || !!val.output.answerText?.trim(), {
    message: "answer artifacts require answerText",
    path: [
        "output",
        "answerText"
    ]
});
const UpdateArtifactRequest = _zod.z.object({
    name: _zod.z.string().trim().min(1).optional(),
    outputType: _zod.z.enum([
        "answer",
        "table",
        "chart"
    ]).optional(),
    query: _models.ArtifactReportQuery.nullish(),
    output: _models.ArtifactOutput.optional(),
    chatHistory: _zod.z.array(_models.ArtifactChatMessage).optional()
});
const RenderRequest = _zod.z.object({
    outputType: _zod.z.enum([
        "answer",
        "table",
        "chart"
    ]),
    query: _models.ArtifactReportQuery.nullish(),
    output: _models.ArtifactOutput
});
